// extracted by css-extract-rspack-plugin
export default {"enter":"crossfade__enter___VLeSK","enterActive":"crossfade__enterActive___vcDYL","exit":"crossfade__exit___t8bAh","exitActive":"crossfade__exitActive___Nxy_l"};